var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMaximize = function SvgMaximize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "maximize_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1112 0v251H0V0h1112Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "maximize_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.73.201.03.027a1.08 1.08 0 0 1 .073.083l.016.02a.798.798 0 0 1 .14.334l.008.067.001.013.001.026L16 .8v4.8a.8.8 0 1 1-1.6 0V2.73l-4.234 4.236a.8.8 0 0 1-1.042.077l-.09-.077a.8.8 0 0 1 0-1.132L13.268 1.6H10.4a.8.8 0 0 1-.794-.7L9.6.8a.8.8 0 0 1 .8-.8h4.817a.808.808 0 0 1 .18.024l.078.024a.8.8 0 0 1 .193.103l.032.025.066.058-.036-.033ZM0 10.4a.8.8 0 1 1 1.6 0l-.001 2.869 4.235-4.235a.8.8 0 0 1 1.042-.077l.09.077a.8.8 0 0 1 0 1.132L2.73 14.4H5.6a.8.8 0 0 1 .794.7l.006.1a.8.8 0 0 1-.8.8H.8a.814.814 0 0 1-.197-.024l-.078-.024a.8.8 0 0 1-.193-.103L.3 15.823l-.065-.057.033.03-.026-.024-.013-.013a.804.804 0 0 1-.217-.424l-.008-.067-.001-.018.001.018L0 15.2v-4.8Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#maximize_svg__a)",
    transform: "translate(-143 -24)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#maximize_svg__b)",
    transform: "translate(143 24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0V0z"
  })))));
};

export default SvgMaximize;